import {Injectable} from '@angular/core';

@Injectable()
export class BlurItemService {
  private static readonly blurItems: Map<string, HTMLElement> = new Map();

  constructor() {
  }

  public static addBlurItem(id: string, blurElement: HTMLElement) {
    if (this.blurItems.has(id)) {
      return;
    }
    this.blurItems.set(id, blurElement)
  }

  public static removeBlurItem(id: string) {
    this.blurItems.delete(id)
  }

  public static clearBlurItems() {
    this.blurItems.clear();
  }

  public static triggerBlurItems() {
    Array.from(this.blurItems.values()).forEach(item => {
      let isTrigger = item.getAttribute("triggerBlurItem") || true;
      if (isTrigger !== 'false' && Reflect.has(item, 'click')) {
        item.click();
      }
    });
    this.clearBlurItems();
  }
}
